import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  search: {
    id: 'studio.xmcVZ0',
    defaultMessage: 'Search',
  },
  ascending: {
    id: 'studio.u7djqV',
    defaultMessage: 'Ascending',
  },
  descending: {
    id: 'studio.aleGqT',
    defaultMessage: 'Descending',
  },
  sort: {
    id: 'studio.25oM9Q',
    defaultMessage: 'Sort',
  },
  ratings: {
    id: 'studio.XYovs/',
    defaultMessage: 'Ratings',
  },
  name: {
    id: 'studio.HAlOn1',
    defaultMessage: 'Name',
  },
  organization: {
    id: 'studio.K56Dim',
    defaultMessage: 'Organization',
  },
  created: {
    id: 'studio.ORGv1Q',
    defaultMessage: 'Created',
  },
  updated: {
    id: 'studio.xrk6zg',
    defaultMessage: 'Updated',
  },
});
